import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/info-red.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "flex flex-row gap-2 items-center pb-1" }
const _hoisted_3 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_4 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_5 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_7 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_8 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_9 = {
  key: 0,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1"
}
const _hoisted_10 = {
  key: 1,
  class: "\n              flex flex-row\n              items-start\n              rounded\n              bg-gray-lp-200\n              text-gray-lp-800 text-12px\n              xxl:text-14px\n              p-4\n              space-x-2\n              mt-2\n            "
}
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "info red"
}, null, -1)
const _hoisted_12 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_13 = { class: "w-1/2 flex flex-col" }
const _hoisted_14 = {
  id: "repair-recipient-address-type'",
  class: "flex flex-row"
}
const _hoisted_15 = { class: "flex flex-row" }
const _hoisted_16 = { class: "mx-2" }
const _hoisted_17 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_19 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_20 = { class: "w-1/2 mr-4" }
const _hoisted_21 = { class: "p-field-checkbox mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectPhoneCountryV2 = _resolveComponent("SelectPhoneCountryV2")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectCustomerV2 = _resolveComponent("SelectCustomerV2")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Card = _resolveComponent("Card")!
  const _component_EditCustomerForm = _resolveComponent("EditCustomerForm")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "flex flex-col p-6",
      isShadow: false
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Icons, { name: "icon-detail-sender" }),
          _createVNode(_component_Title, {
            label: _ctx.$t('revamp.booking.detailRecipient'),
            fontSize: 20
          }, null, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('bookingShipment.column.recipientPhoneNumber'),
              id: "repair-recipient-phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SelectPhoneCountryV2, {
                  column: "Penerima",
                  error: _ctx.phoneNumberError,
                  phone: _ctx.modelValue.phoneReceiver,
                  code: _ctx.modelValue.phoneCodeReceiver,
                  isLoading: _ctx.isLoadingCustomer,
                  options: _ctx.receivers,
                  keyName: "customerPhoneNumber",
                  onSetPhone: _ctx.setPhoneReceiver,
                  onSetPhoneCode: _ctx.setPhoneCodeReceiver,
                  onSetErrorPhoneCode: _ctx.setErrorPhoneCodeReceiver,
                  onEditItem: _ctx.editItem,
                  onSelectItem: _ctx.onChooseReceivers
                }, null, 8, ["error", "phone", "code", "isLoading", "options", "onSetPhone", "onSetPhoneCode", "onSetErrorPhoneCode", "onEditItem", "onSelectItem"])
              ]),
              _: 1
            }, 8, ["label"]),
            _withDirectives(_createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.phoneNumberError.message), 1)
            ], 512), [
              [_vShow, 
              _ctx.phoneNumberError.success &&
                _ctx.phoneNumberError.message &&
                _ctx.accountIsNonForeign
            ]
            ])
          ]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.recipientName'),
            class: "w-full",
            id: "repair-recipient-name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectCustomerV2, {
                column: _ctx.$t('bulkBooking.sender'),
                placeholder: _ctx.$t('bookingShipment.placeholder.recipientName'),
                error: _ctx.error.receiver || false || _ctx.errorMessageNameLocal !== '' && _ctx.errorRepair.receiverName,
                customerName: _ctx.modelValue.receiver,
                "onUpdate:customerName": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.receiver = $event)),
                isLoading: _ctx.isLoadingCustomer,
                options: _ctx.receivers,
                errorCaption: 
              _ctx.errorMessageNameLocal !== ''
                ? _ctx.errorMessageNameLocal
                : _ctx.errorMessageName
            ,
                keyName: "customerPhoneNumber",
                onChange: _cache[2] || (_cache[2] = 
              value => {
                _ctx.validateReceiverName(value);
                _ctx.fetchCustomer(value);
              }
            ),
                onFocus: _cache[3] || (_cache[3] = 
              () => {
                _ctx.$emit('setFieldIndex', 4);
                _ctx.validateReceiverName(_ctx.modelValue.receiver);
              }
            ),
                onEditItem: _ctx.editItem,
                onSelectItem: _ctx.onChooseReceivers
              }, null, 8, ["column", "placeholder", "error", "customerName", "isLoading", "options", "errorCaption", "onEditItem", "onSelectItem"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.recipientAddress'),
            class: "w-full",
            id: "repair-recipient-address"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                type: "textarea",
                modelValue: _ctx.modelValue.addressReceiver,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.addressReceiver = $event)),
                error: 
              _ctx.isShipperAndConsigneeAddressIdentical || _ctx.error.addressReceiver || _ctx.errorMessageAddressLocal !== '' && _ctx.errorRepair.receiverAddress
            ,
                "error-caption": 
              _ctx.errorMessageAddressLocal !== ''
                ? _ctx.errorMessageAddressLocal
                : _ctx.errorMessageAddress
                ? _ctx.$t('bookingShipment.error.recipientAddress')
                : this.$t('bookingShipment.error.sameOriginDestination')
            ,
                preventEnterTextArea: true,
                format: _ctx.replaceNewLine,
                placeholder: _ctx.$t('bookingShipment.placeholder.recipientAddress'),
                maxLength: _ctx.maxAddressLength,
                showMaxLength: true,
                textAreaRows: "1",
                onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('setFieldIndex', 8))),
                onChange: _ctx.validateAddressRecipient
              }, null, 8, ["modelValue", "error", "error-caption", "format", "placeholder", "maxLength", "onChange"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.districtDestinationCity'),
            class: "w-full",
            id: "repair-recipient-district"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                class: "mt-1.5",
                onFilter: _cache[6] || (_cache[6] = search => _ctx.$emit('fetchDestinationCity', search)),
                isLoading: _ctx.isLoadingDestinationCity,
                options: _ctx.destinationCityList,
                keyName: "name",
                keyValue: "id",
                placeholder: 
              _ctx.$t('bookingShipment.placeholder.districtDestinationCity')
            ,
                modelValue: _ctx.modelValue.destinationCity,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.destinationCity = $event)),
                isShowErrorIndicator: _ctx.showErrorDistrict || _ctx.errorRepair.destinationDistrictName,
                onFocus: _ctx.onFocusDestinationCity,
                isShowErrorMessage: _ctx.isShowErrorAddress,
                errorCaption: _ctx.errorMessageDestinationCity || _ctx.errorMessageDestinationDistrict,
                onChange: _ctx.onChangeDistrict
              }, null, 8, ["isLoading", "options", "placeholder", "modelValue", "isShowErrorIndicator", "onFocus", "isShowErrorMessage", "errorCaption", "onChange"]),
              (_ctx.modelValue.destinationCity?.status === 'INACTIVE')
                ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(this.$t("bookingShipment.error.inactiveCity")), 1))
                : _createCommentVNode("", true),
              (_ctx.checkVendorDestinationDistrict())
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode("div", null, _toDisplayString(_ctx.$t('repairBulkBooking.vendorNinjaInfo')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.postalCode'),
            class: "w-full",
            id: "repair-recipient-postal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                serverSide: false,
                onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('setFieldIndex', 10.5))),
                onFilter: _ctx.setPostalCodeDestination,
                placeholder: _ctx.$t('bookingShipment.placeholder.postalCode'),
                class: "mt-2",
                keyName: "name",
                keyValue: "name",
                options: _ctx.postalCodeDestinationOptions,
                modelValue: _ctx.modelValue.postalCodeDestination,
                "onUpdate:modelValue": [
                  _cache[9] || (_cache[9] = ($event: any) => (_ctx.modelValue.postalCodeDestination = $event)),
                  _ctx.updatePostalCode
                ],
                isShowErrorIndicator: 
              _ctx.currentFieldIndex > 10.5 && !_ctx.modelValue.postalCodeDestination || _ctx.errorRepair.destinationPostalCode
            ,
                errorCaption: 
              _ctx.currentFieldIndex > 10.5 && !_ctx.modelValue.postalCodeDestination
                ? _ctx.$t('bookingShipment.error.postalCode')
                : _ctx.errorRepair.destinationPostalCode
                ? _ctx.errorRepair.destinationPostalCodeCaption
                : ''
            ,
                onChange: _ctx.onChangeZipCode
              }, null, 8, ["onFilter", "placeholder", "options", "modelValue", "isShowErrorIndicator", "errorCaption", "onChange", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAddressType, (item, index) => {
                return (_openBlock(), _createBlock("label", {
                  key: index,
                  class: [
                (_ctx.currentFieldIndex > 10.8 && !_ctx.addressTypeValue) ||
                _ctx.isErrorSelectAddressType
                  ? 'radioCustomError'
                  : 'radioCustom'
              , "relative block overflow-hidden"]
                }, [
                  _createVNode("input", {
                    type: "radio",
                    value: _ctx.addressTypeValue,
                    checked: _ctx.modelValue.addressReceiverType === item.value,
                    id: item,
                    onChange: ($event: any) => (_ctx.onSelectAddressType(item.name, item.value)),
                    name: "radio-input",
                    class: "w-full whitespace-no-wrap my-2 z-10 absolute"
                  }, null, 40, ["value", "checked", "id", "onChange"]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode(_component_Icons, {
                      name: item.name === _ctx.$t('bulkBooking.home') ? 'home-type' : 'office',
                      class: "cursor-pointer ml-2 h-6"
                    }, null, 8, ["name"]),
                    _createVNode("span", _hoisted_16, _toDisplayString(item.name), 1)
                  ])
                ], 2))
              }), 128))
            ]),
            _withDirectives(_createVNode("div", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.error.addressType")), 1)
            ], 512), [
              [_vShow, 
              (_ctx.currentFieldIndex > 10.8 && !_ctx.addressTypeValue) ||
                _ctx.isErrorSelectAddressType
            ]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode(_component_Checkbox, {
                id: "recipient",
                modelValue: _ctx.modelValue.isSaveRecipient,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.modelValue.isSaveRecipient = $event)),
                binary: true,
                onFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onSaveCustomer($event, _ctx.modelValue))),
                disabled: _ctx.disableSaveReceiver
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode("label", {
                class: "ml-2.5",
                for: "recipient",
                style: `${_ctx.disableSaveReceiver ? `color:#9e9e9e` : ''}`
              }, _toDisplayString(_ctx.$t('bulkBooking.saveRecipientDetail')), 5)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.isOpenUpload)
      ? (_openBlock(), _createBlock(_component_EditCustomerForm, {
          key: 0,
          isShown: _ctx.isOpenUpload,
          "onUpdate:isShown": _cache[12] || (_cache[12] = ($event: any) => (_ctx.isOpenUpload = $event)),
          customer: _ctx.selectedCustomer,
          onOnEditSuccess: _ctx.onChooseReceivers,
          type: "receiver"
        }, null, 8, ["isShown", "customer", "onOnEditSuccess"]))
      : _createCommentVNode("", true)
  ]))
}